import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useApi from "../../../CustomHooks/useApi";
import { Wallet, CreditCard, Loader2 } from "lucide-react";
import { Carousel } from 'react-responsive-carousel';
import imps from './settlement_images/imps.jpeg'
import upi from './settlement_images/upi.JPG'

import { openPrint } from "../../../Store/Slices/printSlice";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const AepsSettlement1 = () => {
    const navigate = useNavigate();

      const dispatch = useDispatch();


    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");

    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [showRegister, setShowRegister] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [mobileLocked, setMobileLocked] = useState(false);

    const [shouldRedirect, setShouldRedirect] = useState(true);

    // APIs
    const { callApi: checkStatus } = useApi("/payout/status", "GET");
    const { callApi: sendOtpApi } = useApi("/payout/send-otp", "POST");
    const { callApi: verifyOtpApi } = useApi("/payout/verify-otp", "POST");
    
  const { callApi: fetchLedger } = useApi("/admin/transactions/retailer/recent-transactions", "GET");

    /* ================= CHECK CUSTOMER STATUS ================= */
    const handleCheckMobile = async () => {
        if (!/^[6-9]\d{9}$/.test(mobile)) {
            setMessage("Enter valid 10 digit mobile");
            setMessageType("error");
            return;
        }

        setIsLoading(true);
        setMessage("");

        try {
            const res = await checkStatus(null, `?mobile=${mobile}`);

            if (res?.isVerified) {
                navigate("/Settlement2Remitter", {
                    state: { mobile, name },
                });
            } else {
                setShowRegister(true);
                setMobileLocked(false);
            }
        } catch (err) {
            console.error(err);
            setMessage("Server error");
            setMessageType("error");
        }

        setIsLoading(false);
    };

    /* ================= SEND OTP (NO REGISTER API) ================= */
    const handleSendOtp = async () => {
        if (!name || !address) {
            setMessage("Enter name and address");
            setMessageType("error");
            return;
        }

        setIsLoading(true);
        setMessage("");

        try {
            const res = await sendOtpApi({ mobile });

            if (res?.status === "OTP_SENT") {
                setShowOtp(true);
                setMessage(res.message || "OTP sent successfully");
                setMessageType("success");
            } else {
                setMessage("OTP send failed");
                setMessageType("error");
            }
        } catch (err) {
            console.error(err);
            setMessage("OTP send failed");
            setMessageType("error");
        }

        setIsLoading(false);
    };

    /* ================= VERIFY OTP (WITH NAME + ADDRESS) ================= */
    const handleVerifyOtp = async () => {
        if (otp.length !== 6) {
            setMessage("Enter valid 6 digit OTP");
            setMessageType("error");
            return;
        }

        setIsLoading(true);
        setMessage("");

        try {
            const res = await verifyOtpApi({
                mobile,
                otp,
                name,
                address,
            });

            if (res?.status === "VERIFIED" && res?.isVerified) {
                setMessage("Customer verified successfully");
                setMessageType("success");

                setTimeout(() => {
                    navigate("/Settlement2Remitter", {
                        state: { mobile, name },
                    });
                }, 1000);
            } else {
                setMessage("Invalid OTP");
                setMessageType("error");
            }
        } catch (err) {
            console.error(err);
            setMessage("OTP verify failed");
            setMessageType("error");
        }

        setIsLoading(false);
    };

      const [ledger, setLedger] = useState([]);
  const [loadingLedger, setLoadingLedger] = useState(false);

  const mid = useSelector((s) => s.auth.employeeDetails?.username);

     useEffect(() => {
        const loadLedger = async () => {
          if (!mid) return;
          setLoadingLedger(true);
    
          try {
            const res = await fetchLedger(null, `?mid=${mid}`);
    
            // ✅ Sirf data object uthao
            const onlyData = res?.slice(0, 5).map(item => item.data);
    
            setLedger(onlyData || []);
    
          } catch (err) {
            console.error("Ledger fetch failed:", err);
          } finally {
            setLoadingLedger(false);
          }
        };
    
        loadLedger();
      }, [mid]);

    return (<>

        <div className=" py-5 px-4 
                flex flex-col lg:flex-row gap-8">

            {/* LEFT PANEL */}
            <div className="flex-1 ">
                <div className="bg-white w-full h-auto  border border-slate-200 rounded-2xl shadow-md 
                    p-6 sm:p-8 flex flex-col gap-6 ">

                    {/* Heading */}
                    <div className="flex items-start gap-5">
                        <div className="w-14 h-14 rounded-2xl bg-[#F6F6F6] 
                        flex items-center justify-center text-[#12345A] shadow-lg ">
                            {/* <CreditCard className="w-8 h-8" /> */}
                            <Wallet className="w-8 h-8 " />
                        </div>

                        <div>
                            <h2 className="text-2xl font-semibold text-slate-800">
                                Aeps Settlement (IMPS)
                            </h2>
                            <p className="text-gray-500 text-sm mt-1">
                                Verify customer and proceed with secure IMPS Transfers
                            </p>
                        </div>
                    </div>

                    {/* Form Area */}
                    {/* Form Area */}
                    <div className="max-w-full space-y-5">

                        <label className="text-xl font-medium text-slate-700">Mobile Number</label>

                        {/* Input + Button Row */}
                        <div className="flex flex-col sm:flex-row gap-4">

                            {/* Input on Left */}
                            <input
                                type="text"
                                name="phone"
                                inputMode="numeric"
                                value={mobile}
                                maxLength={10}
                                disabled={mobileLocked}
                                onKeyDown={(e) => e.key === 'Enter' && handleCheckMobile()}

                                // onChange={(e) => /^\d*$/.test(e.target.value) && setMobile(e.target.value)}
                                onChange={(e) => {
    if (/^\d*$/.test(e.target.value)) {
        setMobile(e.target.value);
        // ✅ Hide register and OTP fields when the number is edited
        setShowRegister(false); 
        setShowOtp(false);
    }
}}
                                //   className="flex-1 h-[12vh] px-4 py-3 rounded-xl border border-[#12345A] 
                                //              focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                                //              disabled:bg-gray-100 transition text-[22px]  text-red-600 font-bold bg-[#F6F6F6] shadow-lg"
                                className="w-full min-h-[60px] sm:min-h-[70px] px-4 py-3 rounded-xl border border-[#12345A] 
                       focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                       disabled:bg-gray-100 transition text-xl sm:text-[22px] text-red-600 font-bold bg-[#F6F6F6] shadow-sm
                       [&:-webkit-autofill]:[-webkit-text-fill-color:#dc2626] 
                       [&:-webkit-autofill]:[-webkit-box-shadow:0_0_0_1000px_#F6F6F6_inset] 
                       [&:-webkit-autofill]:transition-none"
                                placeholder="Enter 10-digit mobile number"
                            />


                        </div>

                        {/* Button on Right */}
                        {!showRegister && !showOtp && (
                            //                     <button
                            //                         onClick={handleCheckMobile}
                            //     className="sm:w-40 w-full px-4 py-3 bg-indigo-600 hover:bg-indigo-700 
                            //                text-white rounded-xl font-semibold shadow-md transition"
                            //   >
                            //     {isLoading ? "Checking..." : "Check"}
                            //   </button>
                            <button
                                onClick={handleCheckMobile}
                                className="
     w-full 
    px-4 py-3 
    bg-[#12345A] 
    hover:bg-[#0F2E47] 
    text-white 
    rounded-xl 
    font-semibold 
    shadow-md 
    transition
  "
                            >
                                {isLoading ? "Checking..." : "Check"}
                            </button>
                        )}



                        {/* Registration Fields (Name + Address) */}
                        {/* {showRegister && (
                        <div className="space-y-3">
                            <input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Customer Name"
                                // className="w-full px-4 py-3 border rounded-xl"
                //                 className="flex-1 h-[12vh] px-4 py-3 rounded-xl border border-[#12345A] 
                //  focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                //  disabled:bg-gray-100 transition text-xl w-full   bg-[#F6F6F6] shadow-lg"
                className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] 
           focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
           disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6]  shadow-lg"
                            />

                            <input
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Address"
                                // className="w-full px-4 py-3 border rounded-xl"
                //                  className="flex-1 h-[12vh] px-4 py-3 rounded-xl border border-[#12345A] 
                //  focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                //  disabled:bg-gray-100 transition text-xl w-full   bg-[#F6F6F6] shadow-lg "
                className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] 
           focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
           disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                            />

                            <button
                                onClick={handleSendOtp}
                                // className="w-full py-3 bg-indigo-600 text-white rounded-xl font-semibold"
                                 className="
     w-full 
    px-4 py-3 
    bg-[#12345A] 
    hover:bg-[#0F2E47] 
    text-white 
    rounded-xl 
    font-semibold 
    shadow-md 
    transition
  "
                            >
                                {isLoading ? "Sending OTP..." : "Send OTP"}
                            </button>
                        </div>
                    )} */}
                        {showRegister && (
                            <div className="space-y-3">
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleSendOtp()} // Trigger OTP
                                    placeholder="Customer Name"
                                    className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                                />

                                <input
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleSendOtp()} // Trigger OTP
                                    placeholder="Address"
                                    className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                                />

                                <button onClick={handleSendOtp} className="
     w-full px-4 py-3 bg-[#12345A] hover:bg-[#0F2E47] text-white  rounded-xl font-semibold shadow-md transition
  ">
                                    {isLoading ? "Sending OTP..." : "Send OTP"}
                                </button>
                            </div>
                        )}


                        {/* OTP Section */}
                        {/* {showOtp && (
                        <div className="space-y-3">
                            <label className="text-sm font-medium">Enter OTP</label>
                            <input
                                value={otp}
                                maxLength={6}
                                onChange={(e) => /^\d*$/.test(e.target.value) && setOtp(e.target.value)}
                                // className="w-full px-4 py-3 border rounded-xl"
                                
                //                  className="flex-1 h-[12vh] px-4 py-3 rounded-xl border border-[#12345A] 
                //  focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                //  disabled:bg-gray-100 transition text-xl w-full   bg-[#F6F6F6] shadow-lg "
                className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] 
           focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
           disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                            
                            />

                            <button
                                onClick={handleVerifyOtp}
                                className="w-full py-3 bg-green-600 text-white rounded-xl font-semibold flex items-center justify-center gap-2"
                            >
                                {isLoading && <Loader2 className="animate-spin w-5 h-5" />}
                                Verify OTP
                            </button>
                        </div>
                    )} */}
                        {showOtp && (
                            <div className="space-y-3">
                                <label className="text-sm font-medium">Enter OTP</label>
                                <input
                                    value={otp}
                                    maxLength={6}
                                    onChange={(e) => /^\d*$/.test(e.target.value) && setOtp(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleVerifyOtp()} // Trigger Verify
                                    className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                                />

                                <button onClick={handleVerifyOtp} className="w-full py-3 bg-green-600 text-white rounded-xl font-semibold flex items-center justify-center gap-2">
                                    Verify OTP
                                </button>
                            </div>
                        )}

                        {/* Message Alert */}
                        {message && (
                            <div
                                className={`px-4 py-3 rounded-xl text-sm ${messageType === "success"
                                    ? "bg-green-100 text-green-700"
                                    : "bg-red-100 text-red-700"
                                    }`}
                            >
                                {message}
                            </div>
                        )}

                    </div>
                </div>
            </div>

            {/* RIGHT PANEL */}
            {/* <div className="w-full lg:w-[28%]">
                <div className="bg-white border border-slate-200 rounded-2xl shadow-md p-2">
                    <Carousel showArrows={true} showThumbs={false} showStatus={false} infiniteLoop autoPlay={true}
                        interval={3000}
                        stopOnHover={false}
                        swipeable={true}>

                        <div>
                            <img className="rounded-xl" src={imps} />
                        </div>

                        <div>
                            <img className="rounded-xl" src={upi} />
                        </div>
                    </Carousel>
                </div>
            </div> */}


        </div>


{/* table */}

            <div className="bg-white rounded-2xl p-6">
            
                      {/* Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold text-slate-700">
                          Recent Transaction
                        </h3>
                      </div>
            
                      {/* Table */}
                      <div className="overflow-x-auto border rounded-xl">
                        <table className="w-full text-sm">
                          <thead className="bg-slate-100">
                            <tr>
                              <th className="px-3 py-3 text-center">Action</th>
                              <th className="px-3 py-3 text-left">Date</th>
                              <th className="px-3 py-3 text-left">Txn ID</th>
                              <th className="px-3 py-3 text-left">Amount</th>
                              <th className="px-3 py-3 text-left">Beni</th>
                              <th className="px-3 py-3 text-left">Account</th>
                              <th className="px-3 py-3 text-left">Status</th>
                            </tr>
                          </thead>
            
                          <tbody className="divide-y">
                            {loadingLedger ? (
                              <tr>
                                <td colSpan="7" className="py-10 text-center text-slate-500">
                                  Loading...
                                </td>
                              </tr>
                            ) : ledger.length > 0 ? (
                              ledger.map((r, i) => (
                                <tr key={i} className="hover:bg-slate-50">
            
                                  <td className="px-3 py-3 text-center">
                                    <button
                                      onClick={() => dispatch(openPrint(r))}
                                      className="hover:scale-110 transition"
                                    >
                                      🖨
                                    </button>
                                  </td>
            
                                  <td className="px-3 py-3 whitespace-nowrap">
                                    {r.date
                                      ? new Date(r.date).toLocaleDateString("en-GB")
                                      : "-"}
                                  </td>
            
                                  <td className="px-3 py-3 font-medium">
                                    {r.txnId || "-"}
                                  </td>
            
                                  <td className="px-3 py-3 font-semibold text-green-600">
                                    ₹{r.netAmount?.toFixed(2) || r.amount?.toFixed(2) || "0.00"}
                                  </td>
            
                                  <td className="px-3 py-3">
                                    {r.consumerNumber || r.beneficiary_name || "-"}
                                  </td>
            
                                  <td className="px-3 py-3">
                                    {r.beneficiary_account_number || r.aeps_AadhaarNo || "-"}
                                  </td>
            
                                  <td
                                    className={`px-3 py-3 font-semibold ${(r.txnStatus === "SUCCESS" || r.status === "SUCCESS")
                                      ? "text-green-600"
                                      : r.txnStatus === "FAILED"
                                        ? "text-red-600"
                                        : "text-yellow-600"
                                      }`}
                                  >
                                    {r.txnStatus || r.status || "-"}
                                  </td>
            
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="py-10 text-center text-slate-400">
                                  No records found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
            
                    </div>
                    </>



    );
};

export default AepsSettlement1;

